import { type Heatmap, isHeatmap } from '@vizit/organisms';
import * as React from 'react';

const HEATMAP_STORAGE_KEY = 'compare:heatmap';

function useStoredChoice<T extends string>(key: string, isValid: (value: unknown) => value is T, fallback: T) {
  const [value, setValue] = React.useState<T>(() => {
    try {
      const stored = window.localStorage.getItem(key);
      return isValid(stored) ? stored : fallback;
    } catch {
      return fallback;
    }
  });
  const update = React.useCallback(
    (next: T) => {
      setValue(next);
      try {
        window.localStorage.setItem(key, next);
      } catch {}
    },
    [key],
  );
  return [value, update] as const;
}

function useStoredHeatmap() {
  return useStoredChoice<Heatmap>(HEATMAP_STORAGE_KEY, isHeatmap, 'original');
}

export { useStoredChoice, useStoredHeatmap };
